import { getOrgMemberCountsDef } from '../../../../backend/features/organizations/shared/platform-functions/getOrgMemberCountsDef';
import { collectOrgIdsForAnyOrgPermission, requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { sql } from '@juvare/platform-app/Integration';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
export const getOrgMemberCounts = implementTypedPlatformFunction(getOrgMemberCountsDef, (context) => {
    const result = {
        totalMemberCount: 0,
        organizationMembershipMap: {},
    };
    if (requireAnySystemPermission(context.userState, 'all-organizations-admin', 'manage-organizations')) {
        const queryResult = context.dbClient.queryList(buildMemberCountQuery());
        for (const { organizationId, memberCount, organizationPath } of queryResult) {
            result.organizationMembershipMap = Object.assign(Object.assign({}, result.organizationMembershipMap), { [organizationId]: { pendingMemberships: memberCount, path: organizationPath } });
            result.totalMemberCount += memberCount;
        }
        return result;
    }
    else {
        const orgIds = collectOrgIdsForAnyOrgPermission(context.userState, 'manage-members');
        if (orgIds.length > 0) {
            const queryResult = context.dbClient.queryList(buildMemberCountQuery(orgIds));
            for (const { organizationId, memberCount, organizationPath } of queryResult) {
                result.organizationMembershipMap = Object.assign(Object.assign({}, result.organizationMembershipMap), { [organizationId]: { pendingMemberships: memberCount, path: organizationPath } });
                result.totalMemberCount += memberCount;
            }
            return result;
        }
        else {
            return result;
        }
    }
});
function buildMemberCountQuery(orgIds) {
    const query = sql `SELECT oc._id AS "organizationId",
                                  oc.path AS "organizationPath",
                                 COUNT(t.account_id) AS "memberCount"
                          FROM (SELECT UNNEST(c.org_status) org_s, _id account_id
                                FROM account_cache c
                                WHERE system_status = 'active' AND org_status_set && '{"pending"}') t,
                               organization_cache oc
                          WHERE t.org_s = oc._id || '_pending'`;
    if (orgIds && orgIds.length > 0) {
        const clause = sql ` AND oc._id IN(${orgIds})`;
        query.query += clause.query;
        query.params.push(...clause.params);
    }
    query.query += ' GROUP BY oc._id';
    return query;
}
